import { BillingMode } from '../../../../services/exports/Constants';

export default {
  billing_modes: {
    [BillingMode.Stripe]: 'Payment method',
    [BillingMode.InternalInvoicing]: 'Payouts',
  },
};
